import { render, staticRenderFns } from "./CalculateResults.vue?vue&type=template&id=bd1eaa44"
import script from "./CalculateResults.vue?vue&type=script&lang=js"
export * from "./CalculateResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports